import React, { useState, useMemo } from 'react';
import { Container, Row, Col, Input, FormGroup, Label, InputGroup, InputGroupText } from 'reactstrap';
import Breadcrumb from "../../../components/Common/Breadcrumb";
import {
    NeoButton,
    NeoCard,
    NeoTabs,
    NeoModal,
    NeoBadge,
    NeoSearch,
    NeoDropdown,
    NeoInput,
    NeoLoader,
    ConfirmDialog,
    PageLoader,
    OverlayLoader,
    LoadingSkeleton,
    NeoConfirmDialog,
    NeoStatCard,
    NeoTable,
    FormPhotoUpload,
    NeoDatePicker,
    NeoAlert,
    NeoFinancialTable,
    NeoPills,
    NeoSideMenu
} from "../../../components/Common";
import { toast } from 'react-toastify';


const mockFinanceData = [
    { id: 1, description: 'Mensalidade Academia - Felipe', category: 'Receitas recorrentes', dueDate: '2026-06-05', value: 150.00, status: 'Pago', client: 'Felipe Macedo', email: 'felipe.macedo@email.com', paymentMethod: 'Cartão de Crédito', details: 'Assinatura anual recorrente, cobrada mensalmente via Stripe. Renovação automática em 2027.' },
    { id: 2, description: 'Aluguel do Imóvel NeoApp', category: 'Infraestrutura', dueDate: '2026-06-10', value: 2500.00, status: 'Pendente', client: 'Imobiliária Outono', email: 'financeiro@outono.com', paymentMethod: 'Boleto Bancário', details: 'Aluguel comercial da sede central do NeoApp. Vencimento todo dia 10.' },
    { id: 3, description: 'Servidores Google Cloud', category: 'Tecnologia & Cloud', dueDate: '2026-05-28', value: 1280.45, status: 'Atrasado', client: 'Google LLC', email: 'cloud-billing@google.com', paymentMethod: 'Débito Automático', details: 'Fatura de consumo dos servidores de produção Firebase e Cloud Functions. Alerta de pagamento pendente.' },
    { id: 4, description: 'Venda de Equipamento de Natação', category: 'Venda de produtos', dueDate: '2026-06-01', value: 320.00, status: 'Pago', client: 'Ana Oliveira', email: 'ana.oliveira@email.com', paymentMethod: 'Pix', details: 'Venda direta de kit de óculos + touca premium. Pago instantaneamente via Pix.' }
];

/**
 * StyleGuide
 * Página de demonstração interativa do Design System (Estilo Taça Outono).
 * Permite visualizar, testar e copiar tokens de cores, botões, modais, abas,
 * confirm dialogs, loaders e toasts de notificação.
 */
const StyleGuide = () => {
    const [mainTab, setMainTab] = useState('general');
    const [btnLoading, setBtnLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('tab1');
    const [searchValue, setSearchValue] = useState("");
    const [sidemenuActiveId, setSidemenuActiveId] = useState('home');
    const [sidebarSearch, setSidebarSearch] = useState("");

    // Estados de Carregamento
    const [showPageLoader, setShowPageLoader] = useState(false);
    const [showOverlayLoader, setShowOverlayLoader] = useState(false);

    // Estados do NeoConfirmDialog
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    // Estado da Busca na Tabela (Filtro)
    const [tableSearch, setTableSearch] = useState("");

    // Estados do Formulário de Cadastro Interativo
    const [formName, setFormName] = useState("");
    const [formEmail, setFormEmail] = useState("");
    const [formRole, setFormRole] = useState("Consultor de Vendas");
    const [formStatus, setFormStatus] = useState("Ativo");
    const [formPhoto, setFormPhoto] = useState(null);
    const [formBirthDate, setFormBirthDate] = useState("1996-05-15");
    const [formSaving, setFormSaving] = useState(false);

    // ── CONFIGURAÇÕES PARA O NOVO NEOFINANCIALTABLE ──
    const [mockFinanceSearch, setMockFinanceSearch] = useState("");
    const [showEmptyFinancial, setShowEmptyFinancial] = useState(false);
    
    const mainTabs = [
        { id: 'general', label: 'Componentes Gerais', icon: 'mdi-palette' },
        { id: 'financialTable', label: 'Tabela Financeira Expandida (Novo)', icon: 'mdi-table-large' },
        { id: 'sideMenu', label: 'Menu Lateral (Novo)', icon: 'mdi-menu-open' }
    ];

    const mockFinanceSummary = [
        { label: 'Total Pendente', value: 'R$ 2.500,00', count: 1, icon: 'mdi-clock-outline', statusClass: 'status-pending' },
        { label: 'Total Atrasado', value: 'R$ 1.280,45', count: 1, icon: 'mdi-alert-circle-outline', statusClass: 'status-overdue' },
        { label: 'Total Recebido/Pago', value: 'R$ 470,00', count: 2, icon: 'mdi-check-circle-outline', statusClass: 'status-paid' }
    ];


    const mockFinanceColumns = [
        {
            key: 'description',
            label: 'Descrição / Lançamento',
            render: (row, rowIndex, { page, rowsPerPage }) => {
                const indexNum = String((page - 1) * rowsPerPage + rowIndex + 1).padStart(2, '0');
                return (
                    <div>
                        <span className="fw-bold d-block text-brand-primary">
                            <span className="text-brand-secondary me-2">{indexNum}.</span>
                            {row.description}
                        </span>
                        <small className="text-muted font-size-11 d-block ms-4">{row.category}</small>
                    </div>
                );
            }
        },
        {
            key: 'dueDate',
            label: 'Vencimento',
            width: '120px',
            render: (row) => (
                <span className="fw-semibold font-size-12">
                    {new Date(row.dueDate).toLocaleDateString('pt-BR')}
                </span>
            )
        },
        {
            key: 'value',
            label: 'Valor',
            width: '130px',
            align: 'right',
            render: (row) => {
                const textClass = row.status === 'Pago' || row.status === 'Ativo' 
                    ? 'text-success' 
                    : row.status === 'Atrasado' 
                        ? 'text-danger' 
                        : 'text-brand-primary';
                return (
                    <span className={`fw-bold ${textClass}`}>
                        {row.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </span>
                );
            }
        },
        {
            key: 'status',
            label: 'Situação',
            width: '110px',
            align: 'center',
            render: (row) => (
                <NeoBadge color={row.status === 'Pago' || row.status === 'Ativo' ? 'success' : row.status === 'Atrasado' ? 'danger' : 'secondary'}>
                    {row.status}
                </NeoBadge>
            )
        }
    ];

    const renderMockRowDetails = (row) => (
        <Row className="g-3">
            <Col md={4}>
                <div className="font-size-11 text-muted text-uppercase fw-bold mb-1">Beneficiário / Cliente</div>
                <div className="fw-bold font-size-13 text-dark">{row.client}</div>
                <div className="text-muted font-size-11">{row.email}</div>
            </Col>
            <Col md={4}>
                <div className="font-size-11 text-muted text-uppercase fw-bold mb-1">Forma de Pagamento</div>
                <div className="fw-bold font-size-13 text-dark">
                    <i className="mdi mdi-credit-card-outline me-1 text-primary"></i>
                    {row.paymentMethod}
                </div>
            </Col>
            <Col md={4}>
                <div className="font-size-11 text-muted text-uppercase fw-bold mb-1">Detalhes e Observações</div>
                <p className="text-muted font-size-12 mb-0 lh-base">{row.details}</p>
            </Col>
        </Row>
    );

    // Filtra os dados da tabela financeira fictícia
    const filteredMockFinanceData = useMemo(() => {
        if (!mockFinanceSearch) return mockFinanceData;
        const term = mockFinanceSearch.toLowerCase().trim();
        return mockFinanceData.filter(row =>
            row.description.toLowerCase().includes(term) ||
            row.category.toLowerCase().includes(term) ||
            row.client.toLowerCase().includes(term)
        );
    }, [mockFinanceSearch]);



    const copyToClipboard = (text, label) => {
        navigator.clipboard.writeText(text);
        toast.info(`Copiado: ${label} (${text})`);
    };


    // Acionamento do ConfirmDialog
    const handleTriggerConfirm = async () => {
        const isConfirmed = await ConfirmDialog({
            title: 'Deseja excluir este registro?',
            text: 'Essa ação apagará permanentemente o colaborador selecionado!',
            confirmButtonText: 'Sim, excluir permanentemente',
            cancelButtonText: 'Manter colaborador',
            confirmButtonColor: 'var(--color-brand-accent)', // Laranja Ativo
            cancelButtonColor: 'var(--color-brand-primary)'  // Chocolate
        });

        if (isConfirmed) {
            toast.success('Colaborador excluído com sucesso!');
        } else {
            toast.info('Operação cancelada pelo usuário');
        }
    };

    // Acionamento do novo NeoConfirmDialog (React Declarativo)
    const handleNeoConfirmAction = async () => {
        setConfirmLoading(true);
        // Simula processamento de API (e.g. deletando registro)
        await new Promise(resolve => setTimeout(resolve, 2000));
        setConfirmLoading(false);
        setIsConfirmOpen(false);
        toast.success('Ação confirmada e finalizada com sucesso via NeoConfirmDialog!');
    };


    // Simulador de Loaders
    const triggerPageLoader = () => {
        setShowPageLoader(true);
        setTimeout(() => {
            setShowPageLoader(false);
            toast.success('PageLoader concluído!');
        }, 2000);
    };

    const triggerOverlayLoader = () => {
        setShowOverlayLoader(true);
        setTimeout(() => {
            setShowOverlayLoader(false);
            toast.success('OverlayLoader concluído!');
        }, 2000);
    };

    const colors = [
        { name: 'Primary Chocolate', var: '--color-brand-primary', hex: '#482712' },
        { name: 'Secondary Bronze', var: '--color-brand-secondary', hex: '#784b22' },
        { name: 'Accent Active Orange', var: '--color-brand-accent', hex: '#e2661c' },
        { name: 'Canvas Bege', var: '--color-bg-canvas', hex: '#fef5ef' },
        { name: 'Surface White', var: '--color-bg-surface', hex: '#ffffff' }
    ];

    const showTabs = [
        { id: 'tab1', label: 'Cadastro Geral', icon: 'mdi-account-details' },
        { id: 'tab2', label: 'Estatísticas', icon: 'mdi-chart-timeline-variant' },
        { id: 'tab3', label: 'Histórico CRM', icon: 'mdi-history' }
    ];

    const [tableData, setTableData] = useState([
        { id: 1, name: 'Guilherme Silva', photo: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=100&h=100&q=80', role: 'Diretor de Competições', email: 'guilherme.silva@neoapp.com', status: 'Ativo' },
        { id: 2, name: 'Ana Oliveira', photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&h=100&q=80', role: 'Gerente Operacional', email: 'ana.oliveira@neoapp.com', status: 'Ativo' },
        { id: 3, name: 'Felipe Macedo', photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&h=100&q=80', role: 'Administrador Senior', email: 'felipe.macedo@neoapp.com', status: 'Ativo' },
        { id: 4, name: 'Mariana Souza', photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=100&h=100&q=80', role: 'Analista de CRM', email: 'mariana.souza@neoapp.com', status: 'Inativo' },
        { id: 5, name: 'Arthur Santos', photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=100&h=100&q=80', role: 'Coordenador Esportivo', email: 'arthur.santos@neoapp.com', status: 'Ativo' },
        { id: 6, name: 'Beatriz Costa', photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&h=100&q=80', role: 'Recepcionista Head', email: 'beatriz.costa@neoapp.com', status: 'Ativo' },
        { id: 7, name: 'Carlos Santos', photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=100&h=100&q=80', role: 'Consultor de Vendas', email: 'carlos.santos@neoapp.com', status: 'Inativo' }
    ]);

    const tableColumns = [
        {
            key: 'photo',
            label: 'Foto',
            width: '60px',
            align: 'center',
            render: (row) => (
                <div className="neo-table-avatar-wrapper">
                    <img src={row.photo} alt={row.name} className="neo-table-avatar" />
                </div>
            )
        },
        {
            key: 'name',
            label: 'Nome Completo',
            render: (row) => (
                <div>
                    <span className="fw-bold d-block" style={{ color: 'var(--color-brand-primary)' }}>{row.name}</span>
                    <small className="text-muted font-size-11">{row.email}</small>
                </div>
            )
        },
        {
            key: 'role',
            label: 'Cargo / Função'
        },
        {
            key: 'status',
            label: 'Status',
            width: '100px',
            align: 'center',
            render: (row) => (
                <NeoBadge color={row.status === 'Ativo' ? 'success' : 'danger'}>
                    {row.status}
                </NeoBadge>
            )
        },
        {
            key: 'actions',
            label: 'Ações',
            width: '120px',
            align: 'center',
            render: (row) => (
                <div className="neo-table-actions-cell justify-content-center">
                    <NeoButton
                        variant="soft-primary"
                        size="sm"
                        square={true}
                        icon="mdi-pencil-outline"
                        onClick={(e) => {
                            e.stopPropagation();
                            toast.info(`Editar colaborador: ${row.name}`);
                        }}
                    />
                    <NeoButton
                        variant="soft-danger"
                        size="sm"
                        square={true}
                        icon="mdi-trash-can-outline"
                        onClick={async (e) => {
                            e.stopPropagation();
                            const isConfirmed = await ConfirmDialog({
                                title: "Excluir Colaborador?",
                                text: `Deseja mesmo excluir ${row.name}? Esta ação não poderá ser desfeita.`,
                                confirmButtonText: "Sim, excluir",
                                cancelButtonText: "Cancelar"
                            });
                            if (isConfirmed) {
                                setTableData(prev => prev.filter(m => m.id !== row.id));
                                toast.success(`Colaborador ${row.name} excluído!`);
                            }
                        }}
                    />
                </div>
            )
        }
    ];

    // Filtra dados da tabela dinamicamente em tempo real
    const filteredTableData = React.useMemo(() => {
        if (!tableSearch) return tableData;
        const term = tableSearch.toLowerCase();
        return tableData.filter(row =>
            row.name.toLowerCase().includes(term) ||
            row.role.toLowerCase().includes(term) ||
            row.email.toLowerCase().includes(term)
        );
    }, [tableSearch, tableData]);

    // Filtra itens do menu lateral dinamicamente
    const filteredMenuItems = useMemo(() => {
        const rawItems = [
            { id: 'home', label: 'Início', icon: 'mdi-home-outline', description: 'Visão geral do sistema', badge: 'Novidade', badgeVariant: 'accent' },
            { id: 'messages', label: 'Mensagens', icon: 'mdi-email-outline', description: 'Central de notificações', badge: 12, badgeVariant: 'danger' },
            { id: 'users', label: 'Usuários', icon: 'mdi-account-group-outline', description: 'Controle de acesso', badge: 'Ativos', badgeVariant: 'success' },
            { id: 'settings', label: 'Configurações', icon: 'mdi-cog-outline', description: 'Preferências gerais' },
        ];
        if (!sidebarSearch) return rawItems;
        const term = sidebarSearch.toLowerCase();
        return rawItems.filter(item => 
            item.label.toLowerCase().includes(term) || 
            (item.description && item.description.toLowerCase().includes(term))
        );
    }, [sidebarSearch]);


    return (
        <div className="page-content" style={{ backgroundColor: 'var(--color-bg-canvas)', minHeight: '100vh', position: 'relative' }}>
            {/* Simulador FullScreen PageLoader */}
            <PageLoader loading={showPageLoader} />

            {/* Novo Componente Declarativo NeoConfirmDialog */}
            <NeoConfirmDialog
                isOpen={isConfirmOpen}
                toggle={() => setIsConfirmOpen(!isConfirmOpen)}
                title="Deseja excluir este registro?"
                subtitle="Esta operação é permanente e irreversível"
                message="Esta ação apagará permanentemente o colaborador de todas as planilhas e relatórios de auditoria do NeoApp."
                icon="mdi-trash-can-outline"
                iconVariant="danger"
                confirmText="Excluir Colaborador"
                cancelText="Manter Registro"
                onConfirm={handleNeoConfirmAction}
                loading={confirmLoading}
            />


            <Container fluid>
                <Breadcrumb title="Configurações" breadcrumbItem="Design System" />

                {/* TABS DE NÍVEL SUPERIOR DO PLAYGROUND */}
                <div className="mb-4">
                    <NeoTabs
                        tabs={mainTabs}
                        activeTab={mainTab}
                        onChangeTab={setMainTab}
                    />
                </div>

                {mainTab === 'general' && (
                    <>
                        {/* HEADER DA PÁGINA */}
                        <Row className="mb-4 animate__animated animate__fadeIn">
                    <Col xs={12}>
                        <div
                            className="p-4 border d-flex align-items-center justify-content-between bg-white"
                            style={{
                                border: '2px solid var(--color-brand-primary)',
                                borderRadius: '16px',
                                boxShadow: 'var(--shadow-premium-elevated)'
                            }}
                        >
                            <div>
                                <h4 className="fw-bold mb-1" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                                    🎨 NeoApp Component Playground
                                </h4>
                                <p className="text-muted mb-0 font-size-13 fw-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                    Guia visual interativo para validação e testes estéticos do tema <strong>Taça Outono</strong>.
                                </p>
                            </div>
                            <div
                                className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    background: 'rgba(226, 102, 28, 0.08)',
                                    border: '1px solid rgba(226, 102, 28, 0.20)'
                                }}
                            >
                                <i className="mdi mdi-palette-swatch font-size-24" style={{ color: 'var(--color-brand-accent)' }}></i>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* DESIGN TOKENS COMPACTADOS (Inline) */}
                <Row className="mb-4">
                    <Col xs={12}>
                        <div
                            className="p-3 bg-white rounded-3 border"
                            style={{ borderColor: 'rgba(72, 39, 18, 0.12)', boxShadow: 'var(--shadow-premium-soft)' }}
                        >
                            <span className="font-size-11 fw-bold text-muted text-uppercase mb-2.5 d-block" style={{ letterSpacing: '0.8px', fontFamily: 'Outfit, sans-serif' }}>
                                <i className="mdi mdi-format-color-fill me-1 text-primary"></i>
                                Tokens de Cores Globais (Clique para copiar)
                            </span>
                            <div className="d-flex flex-wrap gap-2 align-items-center">
                                {colors.map((c) => (
                                    <div
                                        key={c.var}
                                        className="d-flex align-items-center gap-2 cursor-pointer p-1.5 px-3 rounded-pill border transition-all"
                                        style={{
                                            borderColor: 'rgba(72, 39, 18, 0.08)',
                                            backgroundColor: 'var(--color-bg-canvas)',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => copyToClipboard(`var(${c.var})`, c.name)}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = 'var(--color-brand-accent)';
                                            e.currentTarget.style.transform = 'translateY(-1.5px)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = 'rgba(72, 39, 18, 0.08)';
                                            e.currentTarget.style.transform = 'none';
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: '16px',
                                                height: '16px',
                                                borderRadius: '50%',
                                                backgroundColor: `var(${c.var})`,
                                                border: c.var === '--color-bg-surface' ? '1px solid rgba(72, 39, 18, 0.15)' : 'none'
                                            }}
                                        />
                                        <span className="fw-bold font-size-11" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>{c.name}</span>
                                        <code className="font-size-10 text-muted" style={{ background: 'transparent', padding: 0 }}>{c.var}</code>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* SHOWCASE DOS TRÊS ESTILOS DE CARDS (NEOSTATCARD) */}
                <Row className="mb-4">
                    {/* 1. Estilo Contorno (Contour) */}
                    <Col xl={4} md={6} className="mb-3 mb-xl-0">
                        <NeoStatCard
                            title="Total de Membros"
                            value="1.248"
                            icon="mdi-account-multiple-outline"
                            variant="contour"
                            trend="+12.5%"
                            trendDirection="up"
                            trendLabel="este mês"
                        />
                    </Col>

                    {/* 2. Estilo Suave (Soft) */}
                    <Col xl={4} md={6} className="mb-3 mb-xl-0">
                        <NeoStatCard
                            title="Aulas Agendadas"
                            value="42"
                            icon="mdi-calendar-clock"
                            variant="soft"
                            trend="Estável"
                            trendDirection="neutral"
                            trendLabel="vs ontem"
                        />
                    </Col>

                    {/* 3. Estilo Gradiente (Gradient) */}
                    <Col xl={4} md={12}>
                        <NeoStatCard
                            title="Faturamento Mensal"
                            value="R$ 48.950,00"
                            icon="mdi-cash-multiple"
                            variant="gradient"
                            trend="+8.2%"
                            trendDirection="up"
                            trendLabel="vs mês anterior"
                        />
                    </Col>
                </Row>


                {/* INTERACTIVE ALERTS, CONFIRMS & LOADERS SECTION */}
                <Row className="mb-4">
                    {/* ALERTS E CONFIRM DIALOG */}
                    <Col lg={6} className="mb-4">
                        <NeoCard
                            title="Notificações & Diálogos (Toast & Confirm)"
                            subtitle="Triggers de SweetAlert2 e React-Toastify customizados no estilo Taça Outono."
                            headerIcon="mdi-alert-box-outline"
                        >
                            <div className="mb-4">
                                <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Notificações Toasty</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    <NeoButton variant="success" size="sm" onClick={() => toast.success('Sucesso! Operação realizada com sucesso.')}>
                                        Toast Success
                                    </NeoButton>
                                    <NeoButton variant="danger" size="sm" onClick={() => toast.error('Erro! Ocorreu um problema ao processar.')}>
                                        Toast Error
                                    </NeoButton>
                                    <NeoButton variant="warning" size="sm" onClick={() => toast.warn('Aviso! Verifique os dados inseridos.')}>
                                        Toast Warning
                                    </NeoButton>
                                    <NeoButton variant="primary" size="sm" onClick={() => toast.info('Informação! Novo log registrado na auditoria.')}>
                                        Toast Info
                                    </NeoButton>
                                </div>
                            </div>

                            <div>
                                <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Diálogos de Confirmação (Swal2 & React)</h6>
                                <div className="p-3 border rounded-3 bg-white text-center" style={{ borderColor: 'rgba(72, 39, 18, 0.12)' }}>
                                    <i className="mdi mdi-alert-decagram-outline font-size-36 d-block mb-2 text-warning animate__animated animate__pulse animate__infinite"></i>
                                    <span className="d-block font-size-13 text-muted fw-semibold mb-3">Teste as janelas de exclusão e confirmação seguras do padrão Neo</span>

                                    <div className="d-flex flex-column flex-sm-row justify-content-center gap-2">
                                        <NeoButton
                                            className="flex-fill"
                                            variant="danger"
                                            onClick={handleTriggerConfirm}
                                            icon="mdi-trash-can-outline"
                                        >
                                            ConfirmDialog (Swal2)
                                        </NeoButton>

                                        <NeoButton
                                            className="flex-fill"
                                            variant="primary"
                                            onClick={() => setIsConfirmOpen(true)}
                                            icon="mdi-check-decagram-outline"
                                        >
                                            NeoConfirmDialog (React)
                                        </NeoButton>
                                    </div>
                                </div>
                            </div>
                        </NeoCard>
                    </Col>

                    {/* ESTADOS DE CARREGAMENTO (LOADERS) */}
                    <Col lg={6} className="mb-4">
                        <NeoCard
                            title="Estados de Carregamento & Spinners"
                            subtitle="Showcase de carregamento circular NeoLoader, overlays, capas de entrada e skeletons."
                            headerIcon="mdi-loading"
                            bodyStyle={{ position: 'relative' }} // Necessário para o OverlayLoader relative
                        >
                            {/* OverlayLoader relative ao card */}
                            <OverlayLoader show={showOverlayLoader} label="Atualizando informações do card..." />

                            <Row className="g-3">
                                <Col md={6}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Simular Contêiner & Tela Cheia</h6>
                                    <div className="d-flex flex-column gap-2 mb-3">
                                        <NeoButton variant="primary" onClick={triggerPageLoader} icon="mdi-fullscreen">
                                            FullScreen PageLoader
                                        </NeoButton>
                                        <NeoButton variant="outline" onClick={triggerOverlayLoader} icon="mdi-blur">
                                            Card OverlayLoader
                                        </NeoButton>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Pulsing Skeletons (Shimmer)</h6>
                                    <div className="p-3 border rounded-3 bg-white" style={{ borderColor: 'rgba(72, 39, 18, 0.12)' }}>
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <LoadingSkeleton variant="avatar" size="sm" />
                                            <div className="flex-grow-1">
                                                <LoadingSkeleton variant="text" width="60%" className="mb-1" />
                                                <LoadingSkeleton variant="text" width="40%" />
                                            </div>
                                        </div>
                                        <LoadingSkeleton variant="rect" height="42px" className="rounded-3" />
                                    </div>
                                </Col>

                                {/* MODELOS DE SPINNING CIRCULAR (SÓ ELE / INLINE) */}
                                <Col xs={12} className="mt-4 pt-3 border-top" style={{ borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                                    <h6 className="font-size-12 fw-bold text-brand-primary text-uppercase mb-2" style={{ letterSpacing: '0.5px' }}>
                                        <i className="mdi mdi-loading mdi-spin me-1"></i> Modelos de Spinning Circular (NeoLoader)
                                    </h6>
                                    <p className="font-size-12 text-muted mb-3">
                                        Componentes puros baseados em vetor SVG de alta fidelidade para ações inline (tabelas, botões, carregamentos rápidos) sem travar a interface.
                                    </p>

                                    {/* Grid de Tamanhos */}
                                    <div className="p-3 rounded mb-3" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
                                        <div className="row text-center g-2 align-items-center">
                                            <div className="col-4">
                                                <div className="d-flex align-items-center justify-content-center" style={{ height: '36px' }}>
                                                    <NeoLoader type="inline" size="sm" variant="accent" />
                                                </div>
                                                <div className="font-size-11 fw-bold text-brand-secondary mt-1">Pequeno (sm)</div>
                                                <div className="font-size-10 text-muted">Ações & Botões (20px)</div>
                                            </div>
                                            <div className="col-4">
                                                <div className="d-flex align-items-center justify-content-center" style={{ height: '42px' }}>
                                                    <NeoLoader type="inline" size="md" variant="primary" />
                                                </div>
                                                <div className="font-size-11 fw-bold text-brand-secondary mt-1">Médio (md)</div>
                                                <div className="font-size-10 text-muted">Tabelas & Cards (36px)</div>
                                            </div>
                                            <div className="col-4">
                                                <div className="d-flex align-items-center justify-content-center" style={{ height: '58px' }}>
                                                    <NeoLoader type="inline" size="lg" variant="accent" />
                                                </div>
                                                <div className="font-size-11 fw-bold text-brand-secondary mt-1">Grande (lg)</div>
                                                <div className="font-size-10 text-muted">Módulos & Dash (54px)</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Grid de Cores e Rótulos */}
                                    <div className="row g-2 mb-3">
                                        <div className="col-4">
                                            <div className="p-2 border rounded text-center bg-white" style={{ borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                                                <NeoLoader type="inline" size="sm" variant="accent" label="Accent Orange" />
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="p-2 border rounded text-center bg-white" style={{ borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                                                <NeoLoader type="inline" size="sm" variant="primary" label="Chocolate" />
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="p-2 border rounded text-center bg-dark text-white" style={{ borderColor: 'transparent' }}>
                                                <NeoLoader type="inline" size="sm" variant="white" label="White Mode" />
                                            </div>
                                        </div>
                                    </div>

                                    {/* NOVOS MODELOS NO PADRÃO NEO */}
                                    <div className="mt-4 pt-3 border-top" style={{ borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                                        <h6 className="font-size-12 fw-bold text-brand-primary text-uppercase mb-2" style={{ letterSpacing: '0.5px' }}>
                                            <i className="mdi mdi-dots-horizontal me-1"></i> Bouncing Dots & Linear (Novos Modelos Neo)
                                        </h6>
                                        <p className="font-size-12 text-muted mb-3">
                                            Variações modernas do padrão Neo para fluxos integrados, cabeçalhos de tabela ou mensagens.
                                        </p>

                                        <div className="row g-3">
                                            {/* Bolinhas Ondulantes */}
                                            <div className="col-md-6">
                                                <div className="p-3 border rounded-3 bg-white" style={{ borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                                                    <div className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Bouncing Dots (Ondas)</div>
                                                    <div className="d-flex flex-column gap-3">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <NeoLoader type="dots" variant="accent" label="Enviando dados..." />
                                                        </div>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <NeoLoader type="dots" variant="primary" label="Processando..." />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Linear progress */}
                                            <div className="col-md-6">
                                                <div className="p-3 border rounded-3 bg-white h-100" style={{ borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                                                    <div className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Linear Progress (Brisa)</div>
                                                    <div className="d-flex flex-column gap-3 mt-2">
                                                        <div>
                                                            <div className="font-size-10 text-muted mb-1">Accent Active Orange</div>
                                                            <NeoLoader type="linear" variant="accent" />
                                                        </div>
                                                        <div>
                                                            <div className="font-size-10 text-muted mb-1">Chocolate Theme</div>
                                                            <NeoLoader type="linear" variant="primary" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </NeoCard>
                    </Col>
                </Row>

                <Row>
                    {/* BOTÕES PLAYGROUND */}
                    <Col lg={6} className="mb-4">
                        <NeoCard
                            title="Botonaria Premium"
                            subtitle="Coleção completa de botões idênticos aos templates e fichas administrativas."
                            headerIcon="mdi-gesture-tap-button"
                            headerActions={
                                <NeoButton
                                    size="sm"
                                    variant="outline-primary"
                                    onClick={() => setBtnLoading(!btnLoading)}
                                    icon={btnLoading ? 'mdi-play' : 'mdi-pause'}
                                >
                                    {btnLoading ? 'Parar Simulação' : 'Simular Loading'}
                                </NeoButton>
                            }
                        >
                            {/* Família de Sólidos */}
                            <div className="mb-4">
                                <h6 className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Botões Sólidos Premium</h6>
                                <div className="d-flex flex-wrap gap-3">
                                    <NeoButton variant="primary" loading={btnLoading}>Laranja CTA</NeoButton>
                                    <NeoButton variant="chocolate" loading={btnLoading}>Chocolate</NeoButton>
                                    <NeoButton variant="secondary" loading={btnLoading}>Light / Bege</NeoButton>
                                    <NeoButton variant="success" loading={btnLoading} icon="mdi-check">Success</NeoButton>
                                    <NeoButton variant="danger" loading={btnLoading} icon="mdi-close">Danger</NeoButton>
                                    <NeoButton variant="warning" loading={btnLoading} icon="mdi-alert">Warning</NeoButton>
                                    <NeoButton variant="dark" loading={btnLoading}>Dark Grey</NeoButton>
                                </div>
                            </div>

                            {/* Família Soft / Pastel */}
                            <div className="mb-4">
                                <h6 className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Botões Soft / Pastel (Glassmorphism Suave)</h6>
                                <div className="d-flex flex-wrap gap-3">
                                    <NeoButton variant="soft-primary" loading={btnLoading}>Primary Soft</NeoButton>
                                    <NeoButton variant="soft-chocolate" loading={btnLoading}>Chocolate Soft</NeoButton>
                                    <NeoButton variant="soft-secondary" loading={btnLoading}>Bronze Soft</NeoButton>
                                    <NeoButton variant="soft-success" loading={btnLoading} icon="mdi-check-circle-outline">Success Soft</NeoButton>
                                    <NeoButton variant="soft-danger" loading={btnLoading} icon="mdi-close-circle-outline">Danger Soft</NeoButton>
                                    <NeoButton variant="soft-warning" loading={btnLoading} icon="mdi-alert-circle-outline">Warning Soft</NeoButton>
                                    <NeoButton variant="soft-dark" loading={btnLoading}>Dark Soft</NeoButton>
                                </div>
                            </div>

                            {/* Família de Contornos (Outline) */}
                            <div className="mb-4">
                                <h6 className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Botões de Contorno (Outline)</h6>
                                <div className="d-flex flex-wrap gap-3">
                                    <NeoButton variant="outline-primary" loading={btnLoading}>Outline Laranja</NeoButton>
                                    <NeoButton variant="outline-chocolate" loading={btnLoading}>Outline Chocolate</NeoButton>
                                    <NeoButton variant="outline-secondary" loading={btnLoading}>Outline Bronze</NeoButton>
                                    <NeoButton variant="outline-success" loading={btnLoading} icon="mdi-check">Outline Green</NeoButton>
                                    <NeoButton variant="outline-danger" loading={btnLoading} icon="mdi-close">Outline Red</NeoButton>
                                    <NeoButton variant="outline-warning" loading={btnLoading} icon="mdi-alert">Outline Yellow</NeoButton>
                                    <NeoButton variant="outline-dark" loading={btnLoading}>Outline Dark</NeoButton>
                                </div>
                            </div>

                            {/* Efeito Vidro (Glassmorphism com Backdrop Filter) */}
                            <div className="mb-4">
                                <h6 className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Efeito Vidro (Para imagens ou fundos escuros)</h6>
                                <div
                                    className="p-4 rounded-3 d-flex flex-wrap gap-3 justify-content-center align-items-center"
                                    style={{
                                        background: 'linear-gradient(135deg, var(--color-brand-primary), var(--color-brand-secondary))',
                                        boxShadow: 'inset 0 0 20px rgba(0,0,0,0.15)'
                                    }}
                                >
                                    <NeoButton variant="glass-light" loading={btnLoading} icon="mdi-white-balance-sunny">Glass Light</NeoButton>
                                    <NeoButton variant="glass-dark" loading={btnLoading} icon="mdi-weather-night">Glass Dark</NeoButton>
                                </div>
                            </div>

                            {/* Formatos e Geometrias (Pills, Circles, Links) */}
                            <div className="mb-4">
                                <h6 className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Pílulas e Botões Circulares (Pills & Icon Circles)</h6>
                                <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
                                    <NeoButton variant="primary" pill loading={btnLoading} icon="mdi-check">Pill Laranja</NeoButton>
                                    <NeoButton variant="chocolate" pill loading={btnLoading} icon="mdi-bank">Pill Chocolate</NeoButton>
                                    <NeoButton variant="soft-success" pill loading={btnLoading} icon="mdi-account">Pill Success Soft</NeoButton>
                                    <NeoButton variant="soft-danger" pill loading={btnLoading} icon="mdi-trash-can-outline">Pill Danger Soft</NeoButton>
                                </div>
                                <div className="d-flex flex-wrap gap-3 align-items-center">
                                    <NeoButton variant="secondary" circle loading={btnLoading} icon="mdi-pencil" title="Editar" />
                                    <NeoButton variant="chocolate" circle loading={btnLoading} icon="mdi-trash-can-outline" title="Excluir" />
                                    <NeoButton variant="primary" circle loading={btnLoading} icon="mdi-plus" title="Adicionar" />
                                    <NeoButton variant="success" circle loading={btnLoading} icon="mdi-check" title="Confirmar" />
                                    <NeoButton variant="danger" circle loading={btnLoading} icon="mdi-close" title="Fechar" />
                                    <NeoButton variant="warning" circle loading={btnLoading} icon="mdi-alert" title="Alerta" />
                                    <NeoButton variant="glass-light" circle loading={btnLoading} icon="mdi-magnify" style={{ background: 'rgba(72,39,18,0.1)' }} title="Pesquisar" />
                                </div>
                            </div>

                            {/* Tamanhos e Texto */}
                            <Row className="g-3">
                                <Col md={8}>
                                    <h6 className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Escalonamento de Tamanhos Reais</h6>
                                    <div className="d-flex flex-wrap gap-3 align-items-center">
                                        <NeoButton variant="primary" size="sm" icon="mdi-plus" loading={btnLoading}>Pequeno (32px)</NeoButton>
                                        <NeoButton variant="primary" size="md" icon="mdi-plus" loading={btnLoading}>Médio (38px)</NeoButton>
                                        <NeoButton variant="primary" size="lg" icon="mdi-plus" loading={btnLoading}>Grande (48px)</NeoButton>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <h6 className="font-size-11 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Textos & Links</h6>
                                    <div className="d-flex align-items-center gap-3 pt-1">
                                        <NeoButton variant="link" icon="mdi-open-in-new">Link</NeoButton>
                                        <NeoButton variant="link" icon="mdi-chevron-right" iconRight>Ver Mais</NeoButton>
                                    </div>
                                </Col>
                            </Row>

                            {/* Novo NeoButton com square (Somente Ícone & Retangular 1:1) */}
                            <div className="mt-4 pt-3 border-top animate__animated animate__fadeIn">
                                <h6 className="font-size-11 fw-bold text-muted text-uppercase mb-2" style={{ letterSpacing: '0.5px' }}>
                                    🆕 NeoButton Square (Somente Ícone & Retangular 1:1)
                                </h6>
                                <p className="font-size-12 text-muted mb-3">
                                    Botões contendo apenas ícone com dimensões quadradas perfeitas utilizando a propriedade <code>square={"{true}"}</code>. Ideal para ações de tabelas, barras de ferramentas e botões compactos em cabeçalhos.
                                </p>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <span className="font-size-11 fw-bold text-muted mb-2 d-block">Preenchidos (Filled) por tamanho (sm, md, lg)</span>
                                        <div className="d-flex flex-wrap gap-2 align-items-center">
                                            <NeoButton icon="mdi-plus" variant="primary" size="sm" square={true} title="Adicionar sm" />
                                            <NeoButton icon="mdi-pencil" variant="chocolate" size="md" square={true} title="Editar md" />
                                            <NeoButton icon="mdi-trash-can-outline" variant="danger" size="lg" square={true} title="Excluir lg" />
                                            
                                            <span className="text-muted mx-2">|</span>
                                            
                                            <NeoButton icon="mdi-check" variant="success" size="sm" square={true} title="Salvar sm" />
                                            <NeoButton icon="mdi-alert" variant="warning" size="md" square={true} title="Aviso md" />
                                            <NeoButton icon="mdi-cog-outline" variant="dark" size="lg" square={true} title="Ajustes lg" />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <span className="font-size-11 fw-bold text-muted mb-2 d-block">Contorno (Outlines) por tamanho (sm, md, lg)</span>
                                        <div className="d-flex flex-wrap gap-2 align-items-center">
                                            <NeoButton icon="mdi-plus" variant="outline-primary" size="sm" square={true} title="Adicionar outline sm" />
                                            <NeoButton icon="mdi-pencil" variant="outline-chocolate" size="md" square={true} title="Editar outline md" />
                                            <NeoButton icon="mdi-trash-can-outline" variant="outline-danger" size="lg" square={true} title="Excluir outline lg" />
                                            
                                            <span className="text-muted mx-2">|</span>
                                            
                                            <NeoButton icon="mdi-check" variant="outline-success" size="sm" square={true} title="Salvar outline sm" />
                                            <NeoButton icon="mdi-alert" variant="outline-warning" size="md" square={true} title="Aviso outline md" />
                                            <NeoButton icon="mdi-cog-outline" variant="outline-dark" size="lg" square={true} title="Ajustes outline lg" />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </NeoCard>
                    </Col>

                    {/* BADGES & TYPOGRAPHY */}
                    <Col lg={6} className="mb-4">
                        <NeoCard
                            title="Badges, Etiquetas & Tipografia"
                            subtitle="Visualizadores de status em cápsulas suaves outonadas e tipografia Outfit."
                            headerIcon="mdi-tag-multiple-outline"
                        >
                            <div className="mb-4">
                                <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2" style={{ letterSpacing: '0.5px' }}>Etiquetas Outonadas Suaves</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    <NeoBadge color="primary" icon="mdi-tag">Primary Brown</NeoBadge>
                                    <NeoBadge color="secondary" icon="mdi-account">Secondary Bronze</NeoBadge>
                                    <NeoBadge color="info" icon="mdi-fire">Accent Orange</NeoBadge>
                                    <NeoBadge color="success" icon="mdi-check-circle">Ativo / Concluído</NeoBadge>
                                    <NeoBadge color="warning" icon="mdi-clock-outline">Atrasado / Pendente</NeoBadge>
                                    <NeoBadge color="danger" icon="mdi-close-circle">Inativo / Cancelado</NeoBadge>
                                </div>
                            </div>

                            <div className="mb-4">
                                <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2" style={{ letterSpacing: '0.5px' }}>Etiquetas Sólidas</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    <NeoBadge color="primary" solid icon="mdi-tag">Brown</NeoBadge>
                                    <NeoBadge color="secondary" solid icon="mdi-account">Bronze</NeoBadge>
                                    <NeoBadge color="success" solid icon="mdi-check-circle">Ativo</NeoBadge>
                                    <NeoBadge color="danger" solid icon="mdi-close-circle">Cancelado</NeoBadge>
                                </div>
                            </div>

                            <div>
                                <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2" style={{ letterSpacing: '0.5px' }}>Tipografia Outfit</h6>
                                <div className="p-3 border rounded-3 bg-white" style={{ borderColor: 'rgba(72, 39, 18, 0.12)' }}>
                                    <h5 className="fw-bold mb-1" style={{ color: 'var(--color-brand-primary)', fontSize: '20px', fontFamily: 'Outfit, sans-serif' }}>Outfit Extra Bold 800</h5>
                                    <h6 className="fw-bold mb-1" style={{ color: 'var(--color-brand-primary)', fontSize: '15px', fontFamily: 'Outfit, sans-serif' }}>Outfit Bold 700</h6>
                                    <p className="text-muted mb-0 font-size-13 fw-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                        Outfit Semi Bold 600 - Rótulos e textos do NeoApp.
                                    </p>
                                </div>
                            </div>
                        </NeoCard>
                    </Col>
                </Row>

                {/* ALERTA PLAYGROUND (NEOALERT) */}
                <Row className="mb-4">
                    <Col xs={12}>
                        <NeoCard
                            title="Alertas Unificados (NeoAlert)"
                            subtitle="Caixas informativas e alertas no padrão caramelo-soft (bg-light-soft) com bordas de destaque laterais."
                            headerIcon="mdi-alert-circle-outline"
                        >
                            <Row className="g-3">
                                <Col md={6}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Variantes de Cores</h6>
                                    <div className="d-flex flex-column gap-2">
                                        <NeoAlert color="primary" title="Alerta Primary">
                                            Este é um alerta informativo usando a cor primária chocolate do NeoApp.
                                        </NeoAlert>
                                        <NeoAlert color="info" title="Alerta Info / Destaque">
                                            Informação importante: Novo período de testes de performance agendado.
                                        </NeoAlert>
                                        <NeoAlert color="warning" title="Alerta Warning / Atenção">
                                            Consulte a gerência para iniciar um novo ciclo de avaliações técnicas.
                                        </NeoAlert>
                                        <NeoAlert color="success" title="Alerta Success / Concluído">
                                            Excelente! As avaliações de metodologia foram enviadas com sucesso aos alunos.
                                        </NeoAlert>
                                        <NeoAlert color="danger" title="Alerta Danger / Erro">
                                            Não foi possível carregar os dados cadastrais da turma selecionada.
                                        </NeoAlert>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-2.5" style={{ letterSpacing: '0.5px' }}>Customizações de Ícones & Estilo</h6>
                                    <div className="d-flex flex-column gap-2">
                                        <NeoAlert color="info" icon="mdi-trophy-outline" title="Ícone Customizado">
                                            Você pode definir qualquer ícone MDI customizado para representar a sua notificação.
                                        </NeoAlert>
                                        <NeoAlert color="primary" borderLeftAccent={false} title="Sem Borda Lateral">
                                            Caso prefira um design mais minimalista, a borda lateral de destaque pode ser desativada.
                                        </NeoAlert>
                                        <NeoAlert color="warning" animate={false} title="Sem Animação de Entrada">
                                            Você também pode desativar o efeito fade-in de entrada padrão na tela.
                                        </NeoAlert>
                                        <NeoAlert color="success" title="Conteúdo Flexível">
                                            Você pode renderizar elementos customizados ou múltiplos parágrafos dentro do corpo do alerta.
                                        </NeoAlert>
                                    </div>
                                </Col>
                            </Row>
                        </NeoCard>
                    </Col>
                </Row>

                <Row className="mb-4">
                    {/* BUSCA E MENUS SUSPENSOS PLAYGROUND */}
                    <Col lg={12}>
                        <NeoCard
                            title="Campos de Busca & Menus Suspensos Reutilizáveis (Search & Dropdowns)"
                            subtitle="Novos componentes compartilhados que unificam inputs de pesquisa tátil e menus de ações suspensos."
                            headerIcon="mdi-magnify-plus-outline"
                        >
                            <Row className="g-4">
                                {/* SEÇÃO DE BUSCA */}
                                <Col lg={6}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>
                                        🔍 NeoSearch (Pesquisa Dinâmica Tátil)
                                    </h6>

                                    <div className="d-flex flex-column gap-3">
                                        <div>
                                            <span className="font-size-11 fw-bold text-muted mb-1.5 d-block">Busca Padrão (size="md")</span>
                                            <NeoSearch
                                                value={searchValue}
                                                onChange={(e) => setSearchValue(e.target.value)}
                                                placeholder="Digite algo para ver o botão de limpar..."
                                            />
                                        </div>

                                        <Row className="g-2">
                                            <Col sm={6}>
                                                <span className="font-size-11 fw-bold text-muted mb-1.5 d-block">Busca Pequena (size="sm" - 32px)</span>
                                                <NeoSearch
                                                    size="sm"
                                                    value={searchValue}
                                                    onChange={(e) => setSearchValue(e.target.value)}
                                                    placeholder="Filtrar..."
                                                />
                                            </Col>
                                            <Col sm={6}>
                                                <span className="font-size-11 fw-bold text-muted mb-1.5 d-block">Busca Grande (size="lg" - 48px)</span>
                                                <NeoSearch
                                                    size="lg"
                                                    value={searchValue}
                                                    onChange={(e) => setSearchValue(e.target.value)}
                                                    placeholder="Pesquisa geral..."
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>

                                {/* SEÇÃO DE DROPDOWNS */}
                                <Col lg={6}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>
                                        🎛️ NeoDropdown (Menus de Ação Reutilizáveis)
                                    </h6>

                                    <div className="p-3 border rounded-3 bg-white" style={{ borderColor: 'rgba(72, 39, 18, 0.12)' }}>
                                        <div className="d-flex flex-wrap gap-3 align-items-center justify-content-center py-2">
                                            {/* Dropdown Primário Laranja */}
                                            <div>
                                                <span className="font-size-11 fw-bold text-muted mb-1.5 d-block text-center">Ações Laranja CTA</span>
                                                <NeoDropdown
                                                    label="Gerenciar"
                                                    variant="primary"
                                                    items={[
                                                        { label: "Nova Matrícula", icon: "mdi-plus-box", onClick: () => toast.success("Nova Matrícula clicada") },
                                                        { label: "Ver Relatórios", icon: "mdi-file-chart-outline", onClick: () => toast.info("Relatórios abertos") },
                                                        { divider: true },
                                                        { label: "Suspender Conta", icon: "mdi-pause-circle-outline", onClick: () => toast.warn("Aviso de suspensão") },
                                                    ]}
                                                />
                                            </div>

                                            {/* Dropdown Chocolate Outline */}
                                            <div>
                                                <span className="font-size-11 fw-bold text-muted mb-1.5 d-block text-center">Filtros Chocolate</span>
                                                <NeoDropdown
                                                    label="Filtrar Status"
                                                    variant="outline-chocolate"
                                                    icon="mdi-filter-variant"
                                                    items={[
                                                        { label: "Todos os Alunos", icon: "mdi-account-group-outline", onClick: () => toast.success("Todos selecionados") },
                                                        { label: "Apenas Ativos", icon: "mdi-check-circle-outline", onClick: () => toast.success("Ativos selecionados") },
                                                        { label: "Inativos", icon: "mdi-close-circle-outline", onClick: () => toast.warn("Inativos selecionados") },
                                                    ]}
                                                />
                                            </div>

                                            {/* Dropdown Menu de Contexto (Circles) */}
                                            <div>
                                                <span className="font-size-11 fw-bold text-muted mb-1.5 d-block text-center">Menu Circular (Tabelas)</span>
                                                <NeoDropdown
                                                    circle
                                                    variant="secondary"
                                                    items={[
                                                        { label: "Editar Cadastro", icon: "mdi-pencil", onClick: () => toast.info("Editar aberto") },
                                                        { label: "Registrar Venda", icon: "mdi-currency-usd", onClick: () => toast.success("Registrar aberto") },
                                                        { divider: true },
                                                        { label: "Excluir Aluno", icon: "mdi-trash-can-outline", danger: true, onClick: handleTriggerConfirm }
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </NeoCard>
                    </Col>
                </Row>

                <Row className="mb-4">
                    {/* INPUTS TRADICIONAIS PLAYGROUND */}
                    <Col lg={12}>
                        <NeoCard
                            title="Campos de Entrada Tradicionais (Traditional Inputs)"
                            subtitle="Inputs padronizados na tipografia Outfit, suportando contornos premium, versões planas sem borda, ícones integrados e mensagens de erro."
                            headerIcon="mdi-text-box-outline"
                        >
                            <Row className="g-4">
                                {/* CONTORNADOS E PLANOS */}
                                <Col lg={4}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>
                                        ✏️ Estilos & Variantes
                                    </h6>
                                    <NeoInput
                                        label="Nome Completo (Contornada)"
                                        placeholder="Digite o nome do aluno..."
                                    />
                                    <NeoInput
                                        label="E-mail Corporativo (Plana / Flat)"
                                        flat
                                        icon="mdi-email-outline"
                                        placeholder="aluno@neoapp.com"
                                    />
                                </Col>

                                {/* ESPECIAIS E ÍCONES */}
                                <Col lg={4}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>
                                        📅 Seletores, Datas & Ícones
                                    </h6>
                                    <NeoInput
                                        label="Gênero (Seletor Premium)"
                                        type="select"
                                        options={[
                                            { value: "m", label: "Masculino" },
                                            { value: "f", label: "Feminino" },
                                            { value: "o", label: "Outro" }
                                        ]}
                                        placeholder="Selecione o gênero..."
                                    />
                                    <NeoInput
                                        label="Data de Nascimento"
                                        type="date"
                                        icon="mdi-calendar"
                                        iconRight
                                    />
                                </Col>

                                {/* TAMANHOS E ERROS */}
                                <Col lg={4}>
                                    <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>
                                        🚨 Tamanhos & Validação
                                    </h6>
                                    <NeoInput
                                        label="CPF do Responsável"
                                        placeholder="000.000.000-00"
                                        error="CPF inválido ou não cadastrado no banco."
                                    />
                                    <Row className="g-2">
                                        <Col sm={4}>
                                            <NeoInput label="Pequeno" size="sm" placeholder="sm" />
                                        </Col>
                                        <Col sm={4}>
                                            <NeoInput label="Médio" size="md" placeholder="md" />
                                        </Col>
                                        <Col sm={4}>
                                            <NeoInput label="Grande" size="lg" placeholder="lg" />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </NeoCard>
                    </Col>
                </Row>

                <Row>
                    {/* NAVEGAÇÃO & ABAS */}
                    <Col lg={12} className="mb-4">
                        <NeoCard
                            title="Showcase de Navegação por Abas"
                            subtitle="Abas estilizadas que realizam trocas de conteúdo dinamicamente."
                            headerIcon="mdi-tab-play"
                        >
                            <NeoTabs
                                tabs={showTabs}
                                activeTab={activeTab}
                                onChangeTab={setActiveTab}
                            />

                            <div className="p-4 border rounded-3 bg-white shadow-sm mt-3 animate__animated animate__fadeIn" style={{ borderColor: 'rgba(72, 39, 18, 0.12)' }}>
                                {activeTab === 'tab1' && (
                                    <div className="animate__animated animate__fadeIn">
                                        <h5 className="fw-bold d-flex align-items-center" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                                            <i className="mdi mdi-account-details me-2 font-size-20" style={{ color: 'var(--color-brand-accent)' }}></i>
                                            Dados do Cadastro Geral
                                        </h5>
                                        <p className="text-muted mb-0 font-size-13 fw-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                            Exemplo de painel contendo inputs organizados com cantos redondos de 10px e sem bordas duras.
                                        </p>
                                    </div>
                                )}
                                {activeTab === 'tab2' && (
                                    <div className="animate__animated animate__fadeIn">
                                        <h5 className="fw-bold d-flex align-items-center" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                                            <i className="mdi mdi-chart-timeline-variant me-2 font-size-20" style={{ color: 'var(--color-brand-accent)' }}></i>
                                            Métricas de Performance e Gráficos
                                        </h5>
                                        <p className="text-muted mb-0 font-size-13 fw-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                            Estatísticas outonais limpas com respiros adequados.
                                        </p>
                                    </div>
                                )}
                                {activeTab === 'tab3' && (
                                    <div className="animate__animated animate__fadeIn">
                                        <h5 className="fw-bold d-flex align-items-center" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                                            <i className="mdi mdi-history me-2 font-size-20" style={{ color: 'var(--color-brand-accent)' }}></i>
                                            Histórico CRM de Operações
                                        </h5>
                                        <p className="text-muted mb-0 font-size-13 fw-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                            Listagem de ações e tags de auditoria unificadas.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </NeoCard>
                    </Col>
                </Row>

                <Row>
                    {/* MODAIS INTERATIVOS */}
                    <Col lg={12} className="mb-4">
                        <NeoCard
                            title="Estrutura de Modais Centralizados"
                            subtitle="Clique no botão para simular a abertura de um modal completo com cabeçalho circular e rodapé fixado."
                            headerIcon="mdi-window-maximize"
                        >
                            <div className="text-center py-4 border rounded-3 bg-white shadow-sm" style={{ borderColor: 'rgba(72, 39, 18, 0.12)' }}>
                                <i className="mdi mdi-card-bulleted-settings-outline font-size-40 d-block mb-2" style={{ color: 'var(--color-brand-secondary)' }}></i>
                                <h6 className="fw-bold mb-3" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>Visualização Real de Modal Premium</h6>
                                <NeoButton
                                    variant="primary"
                                    onClick={() => setIsModalOpen(true)}
                                    icon="mdi-arrow-expand-all"
                                >
                                    Abrir Modal Modelo
                                </NeoButton>
                            </div>
                        </NeoCard>
                    </Col>
                </Row>

                <Row className="mb-4">
                    {/* FORMULÁRIO DE CADASTRO INTERATIVO */}
                    <Col lg={12}>
                        <NeoCard
                            title="Cadastro de Novo Colaborador"
                            subtitle="Coleta de dados da equipe contendo seletor de fotos circular com botão de câmera flutuante e compressão integrada."
                            headerIcon="mdi-account-plus-outline"
                        >
                            <Row className="align-items-center">
                                {/* Seletor de Foto (Esquerda) */}
                                <Col md={3} className="text-center border-end mb-4 mb-md-0 py-3 d-flex flex-column align-items-center justify-content-center" style={{ borderColor: 'rgba(72, 39, 18, 0.12) !important' }}>
                                    <span className="font-size-11 fw-bold text-muted text-uppercase mb-3.5 d-block" style={{ letterSpacing: '0.8px', fontFamily: 'Outfit' }}>
                                        Foto de Perfil
                                    </span>
                                    <FormPhotoUpload
                                        photoPreview={formPhoto}
                                        onChange={(base64) => setFormPhoto(base64)}
                                        size="lg"
                                    />
                                </Col>

                                {/* Dados do Cadastro (Direita) */}
                                <Col md={9} className="ps-md-4">
                                    <Row className="g-3">
                                        <Col md={4}>
                                            <NeoInput
                                                id="form-name-input"
                                                label="Nome Completo"
                                                placeholder="Ex: Amanda Bezerra..."
                                                value={formName}
                                                onChange={(e) => setFormName(e.target.value)}
                                                disabled={formSaving}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <NeoInput
                                                label="E-mail Corporativo"
                                                placeholder="amanda.bezerra@neoapp.com"
                                                icon="mdi-email-outline"
                                                value={formEmail}
                                                onChange={(e) => setFormEmail(e.target.value)}
                                                disabled={formSaving}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <NeoDatePicker
                                                label="Data de Nascimento"
                                                value={formBirthDate}
                                                onChange={(dateISO) => setFormBirthDate(dateISO)}
                                                disabled={formSaving}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <NeoInput
                                                label="Cargo / Função"
                                                type="select"
                                                options={[
                                                    { value: "Gerente Operacional", label: "Gerente Operacional" },
                                                    { value: "Diretor de Competições", label: "Diretor de Competições" },
                                                    { value: "Administrador Senior", label: "Administrador Senior" },
                                                    { value: "Analista de CRM", label: "Analista de CRM" },
                                                    { value: "Coordenador Esportivo", label: "Coordenador Esportivo" },
                                                    { value: "Recepcionista Head", label: "Recepcionista Head" },
                                                    { value: "Consultor de Vendas", label: "Consultor de Vendas" }
                                                ]}
                                                value={formRole}
                                                onChange={(e) => setFormRole(e.target.value)}
                                                disabled={formSaving}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <NeoInput
                                                label="Status Inicial"
                                                type="select"
                                                options={[
                                                    { value: "Ativo", label: "Ativo" },
                                                    { value: "Inativo", label: "Inativo" }
                                                ]}
                                                value={formStatus}
                                                onChange={(e) => setFormStatus(e.target.value)}
                                                disabled={formSaving}
                                            />
                                        </Col>
                                    </Row>

                                    {/* Botonaria de Rodapé do Formulário */}
                                    <div className="d-flex gap-2 justify-content-end mt-4 pt-2">
                                        <NeoButton
                                            variant="outline-chocolate"
                                            onClick={() => {
                                                setFormName("");
                                                setFormEmail("");
                                                setFormPhoto(null);
                                                setFormBirthDate("1996-05-15");
                                                toast.info("Formulário limpo!");
                                            }}
                                            disabled={formSaving}
                                        >
                                            Limpar
                                        </NeoButton>
                                        <NeoButton
                                            variant="primary"
                                            icon="mdi-check"
                                            loading={formSaving}
                                            onClick={() => {
                                                if (!formName.trim() || !formEmail.trim()) {
                                                    toast.warn("Por favor, preencha o Nome e o E-mail!");
                                                    return;
                                                }

                                                setFormSaving(true);
                                                // Simulação assíncrona de salvamento
                                                setTimeout(() => {
                                                    const newCollab = {
                                                        id: Date.now(),
                                                        name: formName,
                                                        email: formEmail,
                                                        role: formRole,
                                                        status: formStatus,
                                                        birthDate: formBirthDate,
                                                        photo: formPhoto || 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=100&h=100&q=80' // default avatar
                                                    };

                                                    setTableData(prev => [newCollab, ...prev]);
                                                    setFormSaving(false);
                                                    setFormName("");
                                                    setFormEmail("");
                                                    setFormPhoto(null);
                                                    toast.success(`Colaborador ${newCollab.name} cadastrado com sucesso!`);
                                                }, 1500);
                                            }}
                                        >
                                            Salvar Colaborador
                                        </NeoButton>
                                    </div>
                                </Col>
                            </Row>
                        </NeoCard>
                    </Col>
                </Row>

                <Row className="mb-4">
                    {/* SHOWCASE NEOTABLE */}
                    <Col lg={12}>
                        <NeoCard
                            title="Cadastro de Colaboradores"
                            subtitle="Listagem e gestão de perfis e permissões da equipe da Taça Outono."
                            headerIcon="mdi-table-large"
                            headerActions={
                                <NeoButton
                                    variant="primary"
                                    size="sm"
                                    icon="mdi-plus"
                                    onClick={() => {
                                        const input = document.getElementById("form-name-input");
                                        if (input) {
                                            input.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            setTimeout(() => input.focus(), 500);
                                        }
                                    }}
                                >
                                    Novo Colaborador
                                </NeoButton>
                            }
                        >
                            <NeoTable
                                columns={tableColumns}
                                data={filteredTableData}
                                defaultItemsPerPage={5}
                                emptyMessage="Nenhum colaborador encontrado"
                                onRowClick={(row) => toast.info(`Linha clicada: ${row.name}`)}
                                searchComponent={
                                    <NeoSearch
                                        value={tableSearch}
                                        onChange={(e) => setTableSearch(e.target.value)}
                                        placeholder="Buscar colaborador..."
                                        size="sm"
                                        style={{ width: '220px' }}
                                    />
                                }
                            />
                        </NeoCard>
                    </Col>
                </Row>
                    </>
                )}

                {mainTab === 'sideMenu' && (
                    <div className="animate__animated animate__fadeIn">
                        <Row className="mb-4">
                            <Col lg={12}>
                                <h6 className="font-size-12 fw-bold text-muted text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>
                                    📂 NeoSideMenu (Barra Lateral de Navegação e Categorias)
                                </h6>
                            </Col>
                            
                            <Col lg={3} md={4} className="mb-3">
                                <NeoSideMenu
                                    title="Menu Administrativo"
                                    subtitle="Navegação Geral e Status"
                                    icon="mdi-robot-outline"
                                    items={filteredMenuItems}
                                    activeId={sidemenuActiveId}
                                    onSelect={(id) => {
                                        setSidemenuActiveId(id);
                                        toast.info(`Menu selecionado: ${id}`);
                                    }}
                                    onAdd={() => toast.success("Ação 'Novo' disparada! Abre o modal de criação.")}
                                    searchComponent={
                                        <NeoSearch
                                            size="sm"
                                            value={sidebarSearch}
                                            onChange={(e) => setSidebarSearch(e.target.value)}
                                            placeholder="Filtrar menu..."
                                        />
                                    }
                                    footerActions={
                                        <NeoButton
                                            variant="outline-primary"
                                            size="sm"
                                            className="w-100 fw-bold"
                                            icon="mdi-export"
                                            onClick={() => toast.info("Ação do rodapé disparada! Exportando relatórios...")}
                                        >
                                            Exportar Dados
                                        </NeoButton>
                                    }
                                />
                            </Col>

                            <Col lg={9} md={8} className="mb-3">
                                <NeoCard
                                    title="NeoSideMenu — Especificação Técnica"
                                    subtitle="Como utilizar o novo componente de menu lateral unificado com suporte a slots premium."
                                    headerIcon="mdi-code-json"
                                >
                                    <div className="p-3 bg-light rounded-3 font-size-12 mb-3 border text-dark" style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}>
{`// Exemplo de uso do NeoSideMenu com slots (Search, CTA e Footer):
import { NeoSideMenu, NeoButton, NeoSearch } from "../../../components/Common";

// 1. Itens estruturados com ícones e badges semânticos
const menuItems = [
    { id: 'home', label: 'Início', icon: 'mdi-home', description: 'Dashboard', badge: 'Novo', badgeVariant: 'accent' },
    { id: 'messages', label: 'Mensagens', icon: 'mdi-email', badge: 12, badgeVariant: 'danger' }
];

// 2. Renderização integrada na grade de controle (Master-Detail)
<NeoSideMenu
    title="Menu Administrativo"
    subtitle="Navegação Geral"
    icon="mdi-robot-outline"
    items={menuItems}
    activeId={activeId}
    onSelect={(id) => setActiveId(id)}
    onAdd={handleCreate} // Renderiza automaticamente o botão retangular premium NeoIconButton '+' no cabeçalho
    searchComponent={
        <NeoSearch
            size="sm"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Buscar..."
        />
    }
    footerActions={
        <NeoButton
            variant="outline-primary"
            size="sm"
            className="w-100 fw-bold"
            icon="mdi-export"
            onClick={handleExport}
        >
            Exportar Dados
        </NeoButton>
    }
/>`}
                                    </div>
                                    <p className="font-size-13 mb-0 text-muted">
                                        Este componente centraliza o layout e a lógica interativa das barras de navegação lateral (sidebars). Ele suporta cabeçalhos completos, ícones circulares outonais, badges semânticos dinâmicos (<code>success</code>, <code>accent</code>, <code>chocolate</code>, <code>danger</code>, <code>muted</code>) e slots flexíveis de layout (<code>onAdd</code>, <code>searchComponent</code>, <code>footerActions</code>). É ideal para substituir código duplicado em sidebars de categorias ou menus de configuração, oferecendo perfeita consistência geométrica com os cartões de conteúdo.
                                    </p>
                                </NeoCard>
                            </Col>
                        </Row>
                    </div>
                )}

                {mainTab === 'financialTable' && (
                    <div className="animate__animated animate__fadeIn">
                        <Row>
                            <Col xs={12}>
                                <NeoCard bodyClassName="p-0">
                                    {/* Toggle entre versão com dados e sem dados */}
                                    <div className="d-flex align-items-center justify-content-between px-4 pt-3 pb-2">
                                        <div>
                                            <h6 className="fw-bold mb-0" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif', fontSize: '13px' }}>
                                                <i className="mdi mdi-table-large me-1"></i>
                                                NeoFinancialTable — Playground
                                            </h6>
                                            <span className="text-muted font-size-11">Alterne para visualizar com dados ou estado vazio.</span>
                                        </div>
                                        <NeoPills
                                            options={[
                                                { id: 'data', label: 'Com Dados' },
                                                { id: 'empty', label: 'Sem Dados' }
                                            ]}
                                            activeId={showEmptyFinancial ? 'empty' : 'data'}
                                            onChange={(id) => setShowEmptyFinancial(id === 'empty')}
                                        />
                                    </div>

                                    <NeoFinancialTable
                                        summaryData={!showEmptyFinancial ? mockFinanceSummary : []}
                                        columns={mockFinanceColumns}
                                        data={!showEmptyFinancial ? filteredMockFinanceData : []}
                                        renderRowDetails={renderMockRowDetails}
                                        searchValue={mockFinanceSearch}
                                        onSearchChange={setMockFinanceSearch}
                                        searchPlaceholder="Buscar na tabela modelo..."
                                        defaultItemsPerPage={5}
                                        emptyMessage="Nenhum lançamento financeiro"
                                        emptySubMessage="Adicione novos lançamentos ou ajuste os filtros para visualizar os registros."
                                    />
                                </NeoCard>
                            </Col>
                        </Row>
                    </div>
                )}
            </Container>

            {/* MODAL MODELO DESIGN SYSTEM */}
            <NeoModal
                isOpen={isModalOpen}
                toggle={() => setIsModalOpen(!isModalOpen)}
                title="Configurações de Metas Globais"
                subtitle="Exemplo prático de modal no estilo premium-modal"
                headerIcon="mdi-bullseye-arrow"
                footerActions={
                    <React.Fragment>
                        <NeoButton
                            variant="secondary"
                            onClick={() => setIsModalOpen(false)}
                        >
                            Cancelar
                        </NeoButton>
                        <NeoButton
                            variant="primary"
                            onClick={() => {
                                setIsModalOpen(false);
                                toast.success('Meta Global salva com sucesso!');
                            }}
                            icon="mdi-check"
                        >
                            Salvar Alterações
                        </NeoButton>
                    </React.Fragment>
                }
            >
                <p className="font-size-14 text-muted mb-4 text-center" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Este modal exemplifica o layout unificado com cabeçalho elegante, ícone circular, e botões de controle inferiores perfeitamente simétricos e fixados.
                </p>

                <div className="border p-3 rounded-3" style={{ borderColor: 'rgba(72, 39, 18, 0.12)', backgroundColor: 'var(--color-bg-canvas)' }}>
                    <FormGroup className="mb-3">
                        <Label className="font-size-11 fw-bold text-muted text-uppercase mb-2 d-block" style={{ letterSpacing: '0.5px', fontFamily: 'Outfit, sans-serif' }}>
                            Nome da Meta
                        </Label>
                        <Input
                            type="text"
                            placeholder="Ex: Metas de Venda Anual"
                            className="bg-white"
                            style={{
                                borderRadius: '10px',
                                border: '1.5px solid rgba(72, 39, 18, 0.15)',
                                fontSize: '13px',
                                height: '38px',
                                fontFamily: 'Outfit, sans-serif'
                            }}
                        />
                    </FormGroup>

                    <FormGroup className="mb-0">
                        <Label className="font-size-11 fw-bold text-muted text-uppercase mb-2 d-block" style={{ letterSpacing: '0.5px', fontFamily: 'Outfit, sans-serif' }}>
                            Valor da Meta Estipulado
                        </Label>
                        <InputGroup size="sm">
                            <InputGroupText className="bg-white border-end-0" style={{ borderColor: 'rgba(72, 39, 18, 0.15)' }}>
                                <span className="font-size-12 fw-bold" style={{ color: 'var(--color-brand-primary)' }}>R$</span>
                            </InputGroupText>
                            <Input
                                type="number"
                                placeholder="0,00"
                                className="border-start-0 ps-0 bg-white"
                                style={{
                                    borderColor: 'rgba(72, 39, 18, 0.15)',
                                    borderRadius: '0 10px 10px 0',
                                    fontSize: '13px',
                                    height: '38px',
                                    fontFamily: 'Outfit, sans-serif'
                                }}
                            />
                        </InputGroup>
                    </FormGroup>
                </div>
            </NeoModal>
        </div>
    );
};

export default StyleGuide;
